<template>
    <div>
        <b-alert
            class="p-2"
                :show="showVersionAlert"
            variant="danger"
        >
            <span class="alert-heading">Es wurde eine neue Version der App gefunden. Bitte laden Sie die Seite neu.</span>
            <button class="btn btn-sm btn-outline-success active ml-3" @click="handlePageReload">
                Seite neu laden.
            </button>
        </b-alert>
        <div :class="['alert-wrapper', {'center': notificationSettings.position === notificationPositionEnum.CENTER}]">
            <b-alert
                :show="dismissCountDown"
                dismissible
                @dismissed="closeSuccess"
                @dismiss-count-down="countDownChanged"
                variant="success"
                class="selenium-success"
            >
                <h4 class="alert-heading">Vielen Dank!</h4>
                <p v-for="(message, index) in successMessages" :key="index">{{ message }}</p>
                <b-progress
                    variant="success"
                    :max="dismissSecs"
                    :value="dismissCountDown"
                    height="3px"
                ></b-progress>
            </b-alert>
            <b-alert
                :show="showErrors"
                dismissible
                @dismissed="closeErrors"
                variant="danger"
                class="selenium-error"
            >
                <h4 class="alert-heading">{{ getErrorHeading }}</h4>
                <p v-for="(message, index) in errorMessages" :key="index">{{ message }}</p>
                <div class="justify-content-center d-flex flex-row ml-4">
                    <button class="btn btn-outline-success active" @click="closeErrors">
                        Ok
                    </button>
                </div>
            </b-alert>
        </div>
        <b-overlay :show="showOverlay" no-wrap>
            <template #overlay>
                <div></div>
            </template>
        </b-overlay>
    </div>
</template>

<script>
import {mapActions, mapGetters}   from "vuex";
import {NotificationPositionEnum} from "../../constants/enums";
import {appVersion} from "@/configs";

export default {
    name: "Notification",
    data() {
        return {
            dismissSecs:              2,
            dismissCountDown:         0,
            notificationPositionEnum: NotificationPositionEnum,
        }
    },
    computed: {
        ...mapGetters({
            errorMessages:        'getErrorMessages',
            successMessages:      'getSuccessMessages',
            notificationSettings: 'getNotificationSettings',
            version:              'getVersion',
        }),
        getErrorHeading() {
            return this.notificationSettings.heading || 'Fehler!';
        },
        showErrors() {
            return this.errorMessages.length > 0;
        },
        showOverlay() {
            return this.showErrors && this.notificationSettings.position === this.notificationPositionEnum.CENTER;
        },
        showVersionAlert() {
            return this.version !== 0 && parseFloat(this.version) !== parseFloat(appVersion);
        },
    },
    watch:    {
        successMessages(val) {
            if (val.length) {
                this.showAlert();
            }
        }
    },
    methods:  {
        ...mapActions({
            setErrorMessages:        'setErrorMessages',
            setSuccessMessages:      'setSuccessMessages',
            setNotificationSettings: 'setNotificationSettings',
        }),
        closeErrors() {
            this.setErrorMessages([]);
        },
        closeSuccess() {
            this.setSuccessMessages([]);
            this.dismissCountDown = 0;
        },
        countDownChanged(dismissCountDown) {
            this.dismissCountDown = dismissCountDown;
        },
        showAlert() {
            this.dismissCountDown = this.dismissSecs;
        },
        handlePageReload() {
            window.location.reload();
        }
    }
};
</script>

<style scoped>
.alert-wrapper {
    position: fixed;
    transition: .3s cubic-bezier(.25, .8, .5, 1);
    top: 30px;
    right: 30px;
    z-index: 10;
    width: 100%;
    max-width: 400px;
}

.alert-wrapper.center {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    transition: none;
    z-index: 20;
}
</style>
